export default "__VITE_ASSET__8VJZxMzC__"